module.exports = __webpack_public_path__ + "images/premium2-23de101bf6267c5b1ad3f226a5e741db.jpg";